import { render, staticRenderFns } from "./betting.vue?vue&type=template&id=2c048485&scoped=true&"
import script from "./betting.vue?vue&type=script&lang=js&"
export * from "./betting.vue?vue&type=script&lang=js&"
import style0 from "./betting.vue?vue&type=style&index=0&id=2c048485&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c048485",
  null
  
)

export default component.exports